import { useContext } from 'react';
import { DispatchAreaStoreContext } from './dispatch-area-store-provider';
import type { DispatchAreaStore } from './dispatch-area-store';
import { assertNonNull } from '../queues/utils/assert-non-null';

export function useDispatchAreaStore(): DispatchAreaStore {
    const store = useContext(DispatchAreaStoreContext);
    assertNonNull(store, 'Unexpectedly did not find a dispatch area store instance');
    return store;
}
